import React from 'react';
import { connect } from 'react-redux';
import FaqContentSC, { SearchWrapSC, FaqsBodySC, FaqsHeadlineSC } from './faq-content.styled';
import FaqSearch from '../faq-search';
import CategoryItem from './category-item';

const _FaqContent = ({ faqCategories, allFaqs }) => {
  return (
    <FaqContentSC>
      <SearchWrapSC>
        <FaqSearch />
      </SearchWrapSC>
      <FaqsBodySC>
        <FaqsHeadlineSC>FAQ</FaqsHeadlineSC>
        {faqCategories.map((category) => {
          return <CategoryItem key={category.id} category={category} faqs={allFaqs} />;
        })}
      </FaqsBodySC>
    </FaqContentSC>
  );
};

const mapStateToProps = (state) => {
  return {
    faqCategories: state.faq.categories,
    allFaqs: state.faq.questions,
  };
};

const FaqContent = connect(mapStateToProps)(_FaqContent);

export default FaqContent;
